import React from 'react';
import classnames from 'classnames';
import s from './ThumbOverlayBackground.scss';
var ThumbOverlayBackground = function (_a) {
    var type = _a.type, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], s[type], className) }));
};
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';
export default ThumbOverlayBackground;
//# sourceMappingURL=ThumbOverlayBackground.js.map